import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import PageSectionHeader from '../../../components/PageSectionHeader';
import FlexBox from '../../../../../components/FlexBox';
import OptionsContainer from '../../../components/OptionsContainer';
import messages from '../../messages';
import { required, checkDateOnly, checkFlightDateOnly, checkFlightNumberOnly } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage, ValidateGroup } from '../../../../../components/Validation';
import DatePicker from '../../../components/DatePicker';
import { AdditionalList } from '../Additional';
import Select from 'react-select';
import Textbox from '../../../components/Textbox';
import TextArea from '../../../components/TextArea';
import AsyncButtonSendMail from '../../../../../components/AsyncButtonSendMail';
import HelpText from '../../../../../components/HelpText';
import Label from 'components/Label';
import FlightDatePicker from '../../../components/FlightDatePicker/index';
import AsyncButton from '../../../../../components/AsyncButton/index';
import { stepChangesToYourJourneyTrawickLookup } from '../../../dataMapper/claimCodeMapper';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import FNOLTooltip from '../../../../../components/FNOLTooltip';
export class TripCancellationVersion15AndAbove extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationCounter: 0,
            errors: [],
        };
        this.validatorGroup = new ValidateGroup();
        this.emailMeDocumentButton = _.uniqueId();
        this.clickedItemId = '';
        this.formResets = {
            'form.reasonForTripCancellation': [
                'nameOfEmployer',
                'whenWereYouNotified',
                'dateOfTerminationOrLayoff',
                'howLongWereYouEmployed',
                'wasThisWorkTransfer',
                'nameOfServiceCallingToActiveDuty',
                'dateYouBecame',
                'nameOfCourtOrAuthority',
                'dateToAppearInCourt',
                'nameOfAuthorityHandlingTheIncident',
                'dateOfIncident',
                'chooseAnInsured',
                'fullName',
                'relationshipToTraveler',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
                'nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure',
                'dateOfTransportClosureIncident',
                'dateOfTrafficAccident',
                'nameOfTravelSupplier',
                'whenDidOperationsResume',
                'whatCausedTheServiceCessation',
                'whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable',
                'whereWasUninhabitable',
                'provideDetailsOfTheIncident',
                'dateSicknessOrInjuryBeganTravelCancellation',
                'typeOfTransportTravelCancellation',
                'flightNumber',
                'flightDate',
                'flightDetailsTravelCancellation',
                'cruiseLineDetailsTravelCancellation',
                'otherDetailsTravelCancellation',
                'reasonForTravelCancellation',
            ],
            'form.whoSickOrInjuredCusingTheCancellation': [
                'chooseAnInsured',
                'fullName',
                'relationshipToTraveler',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
            ],
            'form.whoHadDiedCausingTheCancellation': [
                'chooseAnInsured',
                'fullName',
                'pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled',
                'dateOfDeath',
            ],
        };

    }

    flightVerificationTravelCancellation = (flightObjectName) => () => {
        const tripCancellationCode = stepChangesToYourJourneyTrawickLookup.tripCancellation.claimCode;
        const { flightNumber, flightDate } = this.props.form;
        const isFlightNumberValid = checkFlightNumberOnly(flightNumber);
        const isFlightDateValid = checkFlightDateOnly(flightDate);
        if (isFlightNumberValid && isFlightDateValid) {
            if (flightNumber && flightDate) {
                this.props.getFlightStatus(flightNumber, flightDate, flightObjectName, this.props.stepName, tripCancellationCode);
            }
        }
    };

    handleReasonsForTripCancellation = (path) => (event) => {
        const { reasonForTripCancellation } = this.props.form;
        const reasons = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
            ? reasonForTripCancellation.toJS()
            : reasonForTripCancellation || [];
        const listChecked = [...reasons];
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (value) {
            listChecked.push(name);
        } else {
            listChecked.splice(listChecked.indexOf(name), 1);
            const resetFields = this.formResets[path];
            if (resetFields && resetFields.length > 0) {
                this.props.resetFormFields(resetFields);
            }
        }
        this.props.onFormDataChange(path, listChecked);
    };

    handleChange = (path) => (event) => {
        const target = event.target;
        const { onFormDataChange, resetFormFields } = this.props;
        const value = path === 'form.chooseAnInsured' ? event : target.type === 'checkbox' ? target.checked : target.value;
        if (this.formResets[path]) {
            const resetFields = this.formResets[path];
            if (resetFields && resetFields.length > 0) {
                resetFormFields(resetFields);
            }
        }

        onFormDataChange(path, value);
    };

    handleDayChange = (path) => (value) => {
        const { onFormDataChange } = this.props;
        onFormDataChange(path, value);
    };

    handleFlightSelection = (propertyName, index) => {
        this.props.onFormDataChange(propertyName, index);
    };

    summaryFormValue() {
        return _.mapValues(this.props.form, (prop) => prop || 'N/A');
    }

    handleEmailMeButtonClick = (event) => {
        const target = event.currentTarget || event.srcElement;
        this.clickedItemId = target.id;
        this.props.sendPhysicianEmail();
    };

    showSpinnerForElement(elementId) {
        return this.clickedItemId === elementId;
    }

    handleChangeTypeOfTransport = (propertyName) => (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.props.onFormDataChange(propertyName, value);
    };

    renderTravelCancellationAdditionalItems() {
        const { lossInformationItemsTravelCancellation = [] } = this.props.form;
        const newLossInformationItems = this.props.appendIds(lossInformationItemsTravelCancellation);
        const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
        const isReadOnly = submitted || isSummary;

        return (
            <div>
                <AdditionalList
                    data={newLossInformationItems}
                    onChange={this.props.onTravelCancellationItemsChange}
                    isDelayed={false}
                    disabled={isReadOnly}
                    validatorGroup={this.props.validatorGroup}
                    validationCounter={this.props.validationCounter}
                    insuredsList={insuredsList}
                    isClaimForFieldEnabled={isClaimForFieldEnabled}
                />
            </div>
        );
    }

    renderSickOrInjured() {
        const {
            whoSickOrInjuredCusingTheCancellation,
            dateSicknessOrInjuryBeganTravelCancellation,
            enableTimeTravelCancellation,
            chooseAnInsured,
            fullName,
            relationshipToTraveler,
            pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly, insuredsList } = this.props;
        const buttonEmailMeDisable = !!enableTimeTravelCancellation && new Date().getTime() < enableTimeTravelCancellation;
        return (
            <div className={'ml-3'}>
                <div className={'ml-2 col-sm-12 form-group'}>
                    <Label>
                        <FormattedMessage {...messages.whoSickOrInjuredCusingTheCancellation} />
                    </Label>

                    <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="oneOfTravelers"
                                value="oneOfTravelers"
                                checked={whoSickOrInjuredCusingTheCancellation === 'oneOfTravelers'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellation')}
                            />
                            <FormattedMessage {...messages.oneOfTravelers} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellation === 'oneOfTravelers' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-3 form-group'}>
                                    <FormattedMessage {...messages.chooseAnInsured} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Select
                                        name="chooseAnInsured"
                                        isMulti={false}
                                        isDisabled={isReadOnly}
                                        options={insuredsList}
                                        placeholder="Select Insured(s)"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        onChange={this.handleChange('form.chooseAnInsured')}
                                        value={
                                            !!chooseAnInsured && typeof chooseAnInsured.toJS === 'function' ? chooseAnInsured.toJS() : chooseAnInsured
                                        }
                                        getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                                        getOptionValue={(option) => option.id}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="familyMemberOfTraveler"
                                value="familyMemberOfTraveler"
                                checked={whoSickOrInjuredCusingTheCancellation === 'familyMemberOfTraveler'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellation')}
                            />
                            <FormattedMessage {...messages.familyMemberOfTraveler} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellation === 'familyMemberOfTraveler' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-2 form-group'}>
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Textbox
                                        name="fullName"
                                        type="text"
                                        onChange={this.handleChange('form.fullName')}
                                        value={fullName}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}


                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="hostAtDestination"
                                value="hostAtDestination"
                                checked={whoSickOrInjuredCusingTheCancellation === 'hostAtDestination'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellation')}
                            />
                            <FormattedMessage {...messages.hostAtDestination} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellation === 'hostAtDestination' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-2 form-group'}>
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Textbox
                                        name="fullName"
                                        type="text"
                                        onChange={this.handleChange('form.fullName')}
                                        value={fullName}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="someoneElse"
                                value="someoneElse"
                                checked={whoSickOrInjuredCusingTheCancellation === 'someoneElse'}
                                onChange={this.handleChange('form.whoSickOrInjuredCusingTheCancellation')}
                            />
                            <FormattedMessage {...messages.someoneElse} />
                        </label>
                        {whoSickOrInjuredCusingTheCancellation === 'someoneElse' && (
                            <div className='ml-4'>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <Label>
                                            <FormattedMessage {...messages.fullName} />
                                        </Label>
                                        <Textbox
                                            name="fullName"
                                            type="text"
                                            onChange={this.handleChange('form.fullName')}
                                            value={fullName}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <Label>
                                            <FormattedMessage {...messages.relationshipToTraveler} />
                                        </Label>
                                        <Textbox
                                            name="relationshipToTraveler"
                                            type="text"
                                            onChange={this.handleChange('form.relationshipToTraveler')}
                                            value={relationshipToTraveler}
                                            disabled={isReadOnly}
                                        />
                                    </div>

                                </div>


                                <div className={'row'}>
                                    <div className={'col-sm-12'} >
                                        <Label>
                                            <FormattedMessage {...messages.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled} />
                                        </Label>
                                        <TextArea
                                            name="pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled"
                                            type="text"
                                            onChange={this.handleChange('form.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled')}
                                            value={pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled}
                                            disabled={isReadOnly}
                                        />
                                    </div>

                                </div>
                            </div>
                        )}

                    </div>

                    <div className={'row'} style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className={'col-sm-5 form-group'}>
                            <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                            <DatePicker
                                position={'bottom-start'}
                                disabled={isReadOnly}
                                name="dateSicknessOrInjuryBegan"
                                type="text"
                                onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                                value={dateSicknessOrInjuryBeganTravelCancellation}
                            />
                        </div>
                    </div>

                    <div className={'row'} style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className={'col-sm-7 form-group'}>
                            <FormattedMessage {...messages.statementOfAttendingPhysicianTemplate} />
                        </div>
                        <div className={'col-sm-5 form-group'}>
                            <AsyncButtonSendMail
                                id={this.emailMeDocumentButton}
                                className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                                disabled={buttonEmailMeDisable || isReadOnly}
                                loading={this.props.loading}
                                spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                                onClick={this.handleEmailMeButtonClick}
                            >
                                Statement of Attending Physician
                            </AsyncButtonSendMail>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderDeath() {
        const {
            whoHadDiedCausingTheCancellation,
            dateOfDeath,
            chooseAnInsured,
            fullName,
            relationshipToTraveler,
            pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly, insuredsList } = this.props;

        return (
            <div className={'ml-3'}>
                <div className={'ml-2 col-sm-12 form-group'}>
                    <FormattedMessage {...messages.whoHadDiedCausingTheCancellation} />

                    <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="oneOfTravelers"
                                value="oneOfTravelers"
                                checked={whoHadDiedCausingTheCancellation === 'oneOfTravelers'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellation')}
                            />
                            <FormattedMessage {...messages.oneOfTravelers} />
                        </label>
                        {whoHadDiedCausingTheCancellation === 'oneOfTravelers' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-3 form-group'}>
                                    <FormattedMessage {...messages.chooseAnInsured} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Select
                                        name="chooseAnInsured"
                                        isMulti={false}
                                        isDisabled={isReadOnly}
                                        options={insuredsList}
                                        placeholder="Select Insured(s)"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        onChange={this.handleChange('form.chooseAnInsured')}
                                        value={chooseAnInsured}
                                        getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                                        getOptionValue={(option) => option.id}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="familyMemberOfTraveler"
                                value="familyMemberOfTraveler"
                                checked={whoHadDiedCausingTheCancellation === 'familyMemberOfTraveler'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellation')}
                            />
                            <FormattedMessage {...messages.familyMemberOfTraveler} />
                        </label>
                        {whoHadDiedCausingTheCancellation === 'familyMemberOfTraveler' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-2 form-group'}>
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Textbox
                                        name="fullName"
                                        type="text"
                                        onChange={this.handleChange('form.fullName')}
                                        value={fullName}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}


                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="hostAtDestination"
                                value="hostAtDestination"
                                checked={whoHadDiedCausingTheCancellation === 'hostAtDestination'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellation')}
                            />
                            <FormattedMessage {...messages.hostAtDestination} />
                        </label>
                        {whoHadDiedCausingTheCancellation === 'hostAtDestination' && (
                            <div className={'row ml-2'} style={{ alignItems: 'center' }}>
                                <div className={'col-sm-2 form-group'}>
                                    <FormattedMessage {...messages.fullName} />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                    <Textbox
                                        name="fullName"
                                        type="text"
                                        onChange={this.handleChange('form.fullName')}
                                        value={fullName}
                                        disabled={isReadOnly}
                                    />
                                </div>
                            </div>
                        )}

                        <label>
                            <input
                                disabled={isReadOnly}
                                type="radio"
                                name="someoneElse"
                                value="someoneElse"
                                checked={whoHadDiedCausingTheCancellation === 'someoneElse'}
                                onChange={this.handleChange('form.whoHadDiedCausingTheCancellation')}
                            />
                            <FormattedMessage {...messages.someoneElse} />
                        </label>
                        {whoHadDiedCausingTheCancellation === 'someoneElse' && (
                            <div className='ml-4'>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <Label>
                                            <FormattedMessage {...messages.fullName} />
                                        </Label>
                                        <Textbox
                                            name="fullName"
                                            type="text"
                                            onChange={this.handleChange('form.fullName')}
                                            value={fullName}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <Label>
                                            <FormattedMessage {...messages.relationshipToTraveler} />
                                        </Label>
                                        <Textbox
                                            name="relationshipToTraveler"
                                            type="text"
                                            onChange={this.handleChange('form.relationshipToTraveler')}
                                            value={relationshipToTraveler}
                                            disabled={isReadOnly}
                                        />
                                    </div>

                                </div>


                                <div className={'row'}>
                                    <div className={'col-sm-12'} >
                                        <Label>
                                            <FormattedMessage {...messages.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled} />
                                        </Label>
                                        <TextArea
                                            name="pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled"
                                            type="text"
                                            onChange={this.handleChange('form.pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled')}
                                            value={pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled}
                                            disabled={isReadOnly}
                                        />
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>

                    <div className={'row'} style={{ alignItems: 'center', marginLeft: '22px' }}>
                        <div className={'col-sm-3 form-group'}>
                            <FormattedMessage {...messages.dateOfDeath} />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                            <DatePicker
                                position={'bottom-start'}
                                disabled={isReadOnly}
                                name="dateOfDeath"
                                type="text"
                                onDayChange={this.handleDayChange('form.dateOfDeath')}
                                value={dateOfDeath}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderEmploymentTransfer() {
        const {
            nameOfEmployer,
            whenWereYouNotified,
            dateOfTerminationOrLayoff,
            howLongWereYouEmployed,
            wasThisWorkTransfer,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3'}>
                <div className={'row mt-2 ml-2'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfEmployer} />
                        </Label>
                        <Textbox
                            name="nameOfEmployer"
                            type="text"
                            onChange={this.handleChange('form.nameOfEmployer')}
                            value={nameOfEmployer}
                            disabled={isReadOnly}
                        />
                    </div>

                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                </div>

                <div className={'row mt-3 ml-2'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfTerminationOrLayoff} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfTerminationOrLayoff"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfTerminationOrLayoff')}
                            value={dateOfTerminationOrLayoff}
                        />
                    </div>

                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.howLongWereYouEmployed} />
                        </Label>
                        <Textbox
                            name="howLongWereYouEmployed"
                            type="text"
                            onChange={this.handleChange('form.howLongWereYouEmployed')}
                            value={howLongWereYouEmployed}
                            disabled={isReadOnly}
                        />
                    </div>
                </div>
                <div className={'row ml-2 mt-3 form-group'}>
                    <div className={'col-sm-6'}>
                        <FlexBox style={{ justifyContent: 'space-between' }}>
                            <FormattedMessage {...messages.wasThisWorkTransfer} />
                            <FlexBox className='mr-3'>
                                <OptionsContainer>
                                    <input
                                        disabled={isReadOnly}
                                        type="radio"
                                        value="true"
                                        checked={wasThisWorkTransfer === 'true'}
                                        onChange={this.handleChange('form.wasThisWorkTransfer')}
                                    />
                                    <FormattedMessage {...messages.yes} />
                                </OptionsContainer>
                                <OptionsContainer>
                                    <input
                                        disabled={isReadOnly}
                                        type="radio"
                                        value="false"
                                        checked={wasThisWorkTransfer === 'false'}
                                        onChange={this.handleChange('form.wasThisWorkTransfer')}
                                    />
                                    <FormattedMessage {...messages.no} />
                                </OptionsContainer>
                            </FlexBox>
                        </FlexBox>
                    </div>
                </div>
            </div>
        );
    }

    renderCalledToActiveDuty() {
        const {
            nameOfServiceCallingToActiveDuty,
            whenWereYouNotified,
            dateYouBecame,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row mt-2 ml-2'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfServiceCallingToActiveDuty} />
                        </Label>
                        <Textbox
                            name="nameOfServiceCallingToActiveDuty"
                            type="text"
                            onChange={this.handleChange('form.nameOfServiceCallingToActiveDuty')}
                            value={nameOfServiceCallingToActiveDuty}
                            disabled={isReadOnly}
                        />

                    </div>
                </div>

                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateYouBecame} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateYouBecame"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateYouBecame')}
                            value={dateYouBecame}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitness() {
        const {
            nameOfCourtOrAuthority,
            whenWereYouNotified,
            dateToAppearInCourt,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row mt-2 ml-2'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfCourtOrAuthority} />
                        </Label>
                        <Textbox
                            name="nameOfCourtOrAuthority"
                            type="text"
                            onChange={this.handleChange('form.nameOfCourtOrAuthority')}
                            value={nameOfCourtOrAuthority}
                            disabled={isReadOnly}
                        />

                    </div>
                </div>

                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateToAppearInCourt} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateToAppearInCourt"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateToAppearInCourt')}
                            value={dateToAppearInCourt}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderHijackedVictimOfFeloniousAssault() {
        const {
            nameOfAuthorityHandlingTheIncident,
            dateOfIncident,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfAuthorityHandlingTheIncident} />
                        </Label>
                        <Textbox
                            name="nameOfAuthorityHandlingTheIncident"
                            type="text"
                            onChange={this.handleChange('form.nameOfAuthorityHandlingTheIncident')}
                            value={nameOfAuthorityHandlingTheIncident}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfIncident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfIncident"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfIncident')}
                            value={dateOfIncident}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderWeatherOrDisaster() {
        const {
            nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure,
            dateOfTransportClosureIncident,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure} />
                        </Label>
                        <Textbox
                            name="nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure"
                            type="text"
                            onChange={this.handleChange('form.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure')}
                            value={nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfTransportClosureIncident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfTransportClosureIncident"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfTransportClosureIncident')}
                            value={dateOfTransportClosureIncident}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderTrafficAccident() {
        const {
            nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure,
            dateOfTrafficAccident,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure} />
                        </Label>
                        <Textbox
                            name="nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure"
                            type="text"
                            onChange={this.handleChange('form.nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure')}
                            value={nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.dateOfTrafficAccident} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfTrafficAccident"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfTrafficAccident')}
                            value={dateOfTrafficAccident}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBankruptcyOfTravelSupplier() {
        const {
            nameOfTravelSupplier,
            whenWereYouNotified,

        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-3 mb-4'}>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.nameOfTravelSupplier} />
                        </Label>
                        <Textbox
                            name="nameOfTravelSupplier"
                            type="text"
                            onChange={this.handleChange('form.nameOfTravelSupplier')}
                            value={nameOfTravelSupplier}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                </div>
            </div>
        );
    }

    handleChangeFlightDetail = (flightObjectName, propertyName) => (eventOrDay) => {
        const { form } = this.props;
        const flights = form[flightObjectName].flights || [];

        // Determine the value based on whether it's a date picker event or regular input event
        const value = eventOrDay && eventOrDay.target ? eventOrDay.target.value : eventOrDay;

        if (flights.length === 1) {
            // Update first flight's property
            const updatedFlight = { ...flights[0], [propertyName]: value };
            const updatedFlights = [updatedFlight];
            this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
        } else if (flights.length > 1 && form[flightObjectName].selectedFlightIndex !== null) {
            // Update selected flight's property
            const updatedFlights = flights.map((flight, index) => {
                if (index === form[flightObjectName].selectedFlightIndex) {
                    return { ...flight, [propertyName]: value };
                }
                return flight;
            });
            this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
        }
    };

    renderTravelServiceCessation() {
        const {
            whenDidOperationsResume,
            whenWereYouNotified,
            whatCausedTheServiceCessation,
            flightNumber,
            flightDate,
            flightDetailsTravelCancellation = {},
            typeOfTransportTravelCancellation,
            cruiseLineDetailsTravelCancellation,
            otherDetailsTravelCancellation,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isSummary, submitted } = this.props;
        const isReadOnly = submitted || isSummary;
        const isFlightNumberValid = checkFlightNumberOnly(flightNumber);
        const isFlightDateValid = checkFlightDateOnly(flightDate);
        const flights = flightDetailsTravelCancellation.flights || [];
        const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsTravelCancellation.selectedFlightIndex];
        const showSectionFlightDetails = flightDetailsTravelCancellation && (flightDetailsTravelCancellation.onSuccessFlighAPIRequest || flightDetailsTravelCancellation.callFailFlighAPIRequest);
        const isDisable = isReadOnly || (flightDetailsTravelCancellation && (flightDetailsTravelCancellation.onSuccessFlighAPIRequest || !flightDetailsTravelCancellation.manuallyEnterFlight));
        return (
            <div className={'ml-5 mb-4'}>
                <div>
                    <FormattedMessage {...messages.whatCausedTheServiceCessation} />
                </div>
                <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="strikeOfACommonCarrier"
                            value="strikeOfACommonCarrier"
                            checked={whatCausedTheServiceCessation === 'strikeOfACommonCarrier'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.strikeOfACommonCarrier} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="mechanicalBreakdownOfCommonCarrier"
                            value="mechanicalBreakdownOfCommonCarrier"
                            checked={whatCausedTheServiceCessation === 'mechanicalBreakdownOfCommonCarrier'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.mechanicalBreakdownOfCommonCarrier} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="inclementWeatherOrNaturalDisaster"
                            value="inclementWeatherOrNaturalDisaster"
                            checked={whatCausedTheServiceCessation === 'inclementWeatherOrNaturalDisaster'}
                            onChange={this.handleChange('form.whatCausedTheServiceCessation')}
                        />
                        <FormattedMessage {...messages.inclementWeatherOrNaturalDisaster} />
                    </label>
                </div>
                <div className={'row ml-2 mt-4'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenDidOperationsResume} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenDidOperationsResume"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenDidOperationsResume')}
                            value={whenDidOperationsResume}
                        />
                    </div>
                </div>
                {whatCausedTheServiceCessation !== '' && (
                    <div>
                        <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
                            <FormattedMessage {...messages.typeOfTransport} />
                        </div>
                        <div className={'ml-2 row pt-2'}>
                            <div className={'col-sm-12 form-group'}>
                                <FlexBox>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="airline"
                                            checked={typeOfTransportTravelCancellation === 'airline'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                        />
                                        <FormattedMessage {...messages.airline} />
                                    </OptionsContainer>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="cruiseLine"
                                            checked={typeOfTransportTravelCancellation === 'cruiseLine'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                        />
                                        <FormattedMessage {...messages.cruiseLine} />
                                    </OptionsContainer>
                                    <OptionsContainer>
                                        <input
                                            disabled={isReadOnly}
                                            type="radio"
                                            value="other"
                                            checked={typeOfTransportTravelCancellation === 'other'}
                                            onChange={this.handleChangeTypeOfTransport('form.typeOfTransportTravelCancellation')}
                                        />
                                        <FormattedMessage {...messages.other} />
                                    </OptionsContainer>
                                </FlexBox>
                            </div>
                        </div>
                        {typeOfTransportTravelCancellation === 'airline' &&
                            <div className={'ml-2'}>
                                <PageSectionHeader>
                                    <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                                </PageSectionHeader>
                                <div className={'row'}>
                                    <div className={'col-sm-4 form-group'}>
                                        <Validate
                                            name="flightNumber"
                                            validators={[checkFlightNumberOnly, required]}
                                            group={this.validatorGroup}
                                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                            validationCounter={this.state.validationCounter}
                                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                            defaultValue={flightNumber}
                                            fieldName={messages.flightNumber}
                                        >
                                            <Textbox
                                                name="flightNumber"
                                                type="text"
                                                onChange={this.handleChange('form.flightNumber')}
                                                value={flightNumber}
                                                disabled={isReadOnly}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.flightNumber}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkFlightNumberOnly">
                                                <FormattedMessage
                                                    {...messages.checkFlightNumber}
                                                    values={messages.flightNumber}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-4 form-group'}>
                                        <Validate
                                            name="flightDate"
                                            validators={[checkFlightDateOnly, required]}
                                            group={this.validatorGroup}
                                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                            validationCounter={this.state.validationCounter}
                                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                            defaultValue={flightDate}
                                            fieldName={messages.flightDate}
                                        >
                                            <FlightDatePicker
                                                position={'bottom-start'}
                                                disabled={isReadOnly}
                                                name="flightDate"
                                                type="text"
                                                onDayChange={this.handleDayChange('form.flightDate')}
                                                value={flightDate}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.flightDate}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkFlightDateOnly">
                                                <FormattedMessage
                                                    {...messages.checkFlightDate}
                                                    values={messages.flightDate}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-2 form-group'}></div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-12 form-group'}>
                                        <AsyncButton
                                            id="searchFlightButton"
                                            className={'btn-authentication'}
                                            disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                                            loading={this.props.loading}
                                            spinner={this.showSpinnerForElement('searchFlightButton')}
                                            onClick={this.flightVerificationTravelCancellation('flightDetailsTravelCancellation')}
                                        >
                                            Search Flight
                                        </AsyncButton>
                                    </div>
                                </div>
                                {flightDetailsTravelCancellation.onPendingFlighAPIRequest && (
                                    <div className={'ml-2 row'}>
                                        <div style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage {...messages.pendingFlightApiRequest} />
                                        </div>
                                    </div>
                                )}
                                {flightDetailsTravelCancellation.callFailFlighAPIRequest && flightDetailsTravelCancellation && flightDetailsTravelCancellation.error && (
                                    <div className={'row'}>
                                        <div className={'col-sm-12'} style={{ color: 'red' }}>
                                            {flightDetailsTravelCancellation.error}
                                        </div>
                                    </div>
                                )}
                                {flightDetailsTravelCancellation.callFailFlighAPIRequest && flightDetail && (
                                    <div className={'row'}>
                                        <div className={'form-group col-md-6'}>
                                            <OptionsContainer>
                                                <input
                                                    disabled={isReadOnly}
                                                    type="checkbox"
                                                    name="signature"
                                                    checked={flightDetailsTravelCancellation.manuallyEnterFlight === true}
                                                    onChange={this.handleChange('form.flightDetailsTravelCancellation.manuallyEnterFlight')}
                                                />
                                                <span>
                                                    <FormattedMessage {...messages.manuallyEnterFlight} />
                                                </span>
                                            </OptionsContainer>
                                        </div>
                                        <div className={'form-group col-md-6'}>
                                        </div>
                                    </div>
                                )}
                                {(flightDetailsTravelCancellation.onSuccessFlighAPIRequest && flights.length > 1) && (
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <PageSectionHeader>
                                                <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                                            </PageSectionHeader>
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th />
                                                            <th><FormattedMessage {...messages.originAirport} /></th>
                                                            <th><FormattedMessage {...messages.destinationAirport} /></th>
                                                            <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {flights.map((flight, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="radio"
                                                                        name="selectedFlight"
                                                                        value={index}
                                                                        checked={flightDetailsTravelCancellation.selectedFlightIndex === index}
                                                                        onChange={() => this.handleFlightSelection('form.flightDetailsTravelCancellation.selectedFlightIndex', index)}
                                                                        disabled={isReadOnly}
                                                                    />
                                                                </td>
                                                                <td>{flight.originAirport}</td>
                                                                <td>{flight.destinationAirport}</td>
                                                                <td>{flight.flightDate}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(showSectionFlightDetails && flightDetail) && (
                                    <div className={'row'}>
                                        <div className={'col-sm-12'}>
                                            <Section>
                                                <ControlContainer className={'ml-3'}>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-2'}>
                                                        </div>
                                                        <div className={'col-sm-3'}>
                                                            <h4>
                                                                <FormattedMessage {...messages.flightDetails} />
                                                            </h4>
                                                        </div>
                                                        <div className={'col-sm-7'}>
                                                            <strong>
                                                                <FormattedMessage {...messages.searchSuccess} />:
                                                            </strong>{' '}
                                                            {flightDetailsTravelCancellation.success ? 'Yes' : 'No'}
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.flightNumber} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="flightNumber"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'flightNumber')}
                                                                value={flightDetail.flightNumber}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.flightDate} />
                                                            </PageSectionHeader>
                                                            <DatePicker
                                                                name="flightDate"
                                                                type="text"
                                                                onDayChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'flightDate')}
                                                                value={flightDetail.flightDate}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-12 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.airline} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="airline"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'airline')}
                                                                value={flightDetail.airline}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={'row'}>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.originAirport} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="originAirport"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'originAirport')}
                                                                value={flightDetail.originAirport}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.destinationAirport} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="destinationAirport"
                                                                type="text"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'destinationAirport')}
                                                                value={flightDetail.destinationAirport}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                    </div>
                                                    {!isDisable && (
                                                        <div className={'row'}>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledOut} />
                                                                </PageSectionHeader>
                                                                <DatePicker
                                                                    name="scheduledOut"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'scheduledOut')}
                                                                    value={flightDetail.scheduledOut}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledIn} />
                                                                </PageSectionHeader>
                                                                <DatePicker
                                                                    name="scheduledIn"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'scheduledIn')}
                                                                    value={flightDetail.scheduledIn}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {isDisable && (
                                                        <div className={'row'}>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledOut} />
                                                                </PageSectionHeader>
                                                                <Textbox
                                                                    name="scheduledOut"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'scheduledOut')}
                                                                    value={flightDetail.scheduledOut}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                            <div className={'col-sm-6 form-group'}>
                                                                <PageSectionHeader>
                                                                    <FormattedMessage {...messages.scheduledIn} />
                                                                </PageSectionHeader>
                                                                <Textbox
                                                                    name="scheduledIn"
                                                                    type="text"
                                                                    onDayChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'scheduledIn')}
                                                                    value={flightDetail.scheduledIn}
                                                                    disabled={isDisable}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={'row'}>
                                                        <div className={'col-sm-3 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.departureDelay} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="departureDelay"
                                                                type="number"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'departureDelay')}
                                                                value={flightDetail.departureDelay}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-3 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.arrivalDelay} />
                                                            </PageSectionHeader>
                                                            <Textbox
                                                                name="arrivalDelay"
                                                                type="number"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'arrivalDelay')}
                                                                value={flightDetail.arrivalDelay}
                                                                disabled={isDisable}
                                                            />
                                                        </div>
                                                        <div className={'col-sm-6 form-group'}>
                                                            <PageSectionHeader>
                                                                <FormattedMessage {...messages.cancelled} />
                                                            </PageSectionHeader>
                                                            <select
                                                                name="cancelled"
                                                                className="form-control"
                                                                onChange={this.handleChangeFlightDetail('flightDetailsTravelCancellation', 'cancelled')}
                                                                value={flightDetail.cancelled || ''}
                                                                disabled={isDisable}
                                                            >
                                                                <option value="">Select status</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </ControlContainer>
                                            </Section>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        {typeOfTransportTravelCancellation === 'cruiseLine' &&
                            <div className={'ml-2'}>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.cruiseLine} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="cruiseLine"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.cruiseLine')}
                                            value={cruiseLineDetailsTravelCancellation.cruiseLine}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.cruiseNumber} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="cruiseNumber"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.cruiseNumber')}
                                            value={cruiseLineDetailsTravelCancellation.cruiseNumber}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="departureDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelCancellation.departureDate')}
                                            value={cruiseLineDetailsTravelCancellation.departureDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.arrivalDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="arrivalDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.cruiseLineDetailsTravelCancellation.arrivalDate')}
                                            value={cruiseLineDetailsTravelCancellation.arrivalDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departurePort} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="departurePort"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.departurePort')}
                                            value={cruiseLineDetailsTravelCancellation.departurePort}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.arrivalPort} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="arrivalPort"
                                            type="text"
                                            onChange={this.handleChange('form.cruiseLineDetailsTravelCancellation.arrivalPort')}
                                            value={cruiseLineDetailsTravelCancellation.arrivalPort}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {typeOfTransportTravelCancellation === 'other' &&
                            <div className={'ml-2'}>
                                <div className={'row'}>
                                    <div className={'col-sm-12 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                                        </PageSectionHeader>
                                        <TextArea
                                            name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelCancellation.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                                            value={otherDetailsTravelCancellation.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureDate} />
                                        </PageSectionHeader>
                                        <DatePicker
                                            name="departureDate"
                                            type="text"
                                            onDayChange={this.handleDayChange('form.otherDetailsTravelCancellation.departureDate')}
                                            value={otherDetailsTravelCancellation.departureDate}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.departureLocation} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="departureLocation"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelCancellation.departureLocation')}
                                            value={otherDetailsTravelCancellation.departureLocation}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.destination} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="destination"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelCancellation.destination')}
                                            value={otherDetailsTravelCancellation.destination}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.descriptionOfTravelType} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="descriptionOfTravelType"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelCancellation.descriptionOfTravelType')}
                                            value={otherDetailsTravelCancellation.descriptionOfTravelType}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                        <PageSectionHeader>
                                            <FormattedMessage {...messages.descriptionOfEvent} />
                                        </PageSectionHeader>
                                        <Textbox
                                            name="descriptionOfEvent"
                                            type="text"
                                            onChange={this.handleChange('form.otherDetailsTravelCancellation.descriptionOfEvent')}
                                            value={otherDetailsTravelCancellation.descriptionOfEvent}
                                            disabled={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                )}
            </div>
        );
    }

    renderNaturalDisasterResidence() {
        const {
            whenWereYouNotified,
            whereWasUninhabitable,
            whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable,

        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-5 mb-4'}>
                <div>
                    <FormattedMessage {...messages.whereWasUninhabitable} />
                </div>
                <div style={{ display: 'grid', margin: '8px 8px 8px 15px' }}>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="primaryResidence"
                            value="primaryResidence"
                            checked={whereWasUninhabitable === 'primaryResidence'}
                            onChange={this.handleChange('form.whereWasUninhabitable')}
                        />
                        <FormattedMessage {...messages.primaryResidence} />
                    </label>
                    <label>
                        <input
                            disabled={isReadOnly}
                            type="radio"
                            name="destination"
                            value="destination"
                            checked={whereWasUninhabitable === 'destination'}
                            onChange={this.handleChange('form.whereWasUninhabitable')}
                        />
                        <FormattedMessage {...messages.destination} />
                    </label>
                </div>

                <div className={'row ml-2'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable')}
                            value={whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderTerroristIncident() {
        const {
            whenWereYouNotified,
            provideDetailsOfTheIncident,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isReadOnly } = this.props;

        return (
            <div className={'ml-5 mb-4'}>
                <div className={''}>
                    <Label>
                        <FormattedMessage {...messages.provideDetailsOfTheIncident} />
                    </Label>
                    <TextArea
                        name="provideDetailsOfTheIncident"
                        type="text"
                        onChange={this.handleChange('form.provideDetailsOfTheIncident')}
                        value={provideDetailsOfTheIncident}
                        disabled={isReadOnly}
                    />
                </div>

                <div className={'row mt-2'} style={{ alignItems: 'end' }}>
                    <div className={'col-sm-6'}>
                        <Label>
                            <FormattedMessage {...messages.whenWereYouNotified} />
                        </Label>
                        <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="whenWereYouNotified"
                            type="text"
                            onDayChange={this.handleDayChange('form.whenWereYouNotified')}
                            value={whenWereYouNotified}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            tripCancellation,
            reasonForTripCancellation,
            dateTravelCancellation,
            reasonForTravelCancellation,
        } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
        const { isSummary, submitted, jsonVersion, isClaimGroupAllowed } = this.props;
        const reasonForTripCancellations = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
            ? reasonForTripCancellation.toJS()
            : reasonForTripCancellation || [];

        const isReadOnly = submitted || isSummary;
        const isOnlyOne = reasonForTripCancellations.length > 0;
        const isRenderTripCancellationForAnyReason = !!stepChangesToYourJourneyTrawickLookup.tripCancellationForAnyReason.claimCode;
        const isSicknessOrInjuryChecked = reasonForTripCancellations.includes('sicknessOrInjury');
        const isDeathChecked = reasonForTripCancellations.includes('death');
        const isEmploymentTransferChecked = reasonForTripCancellations.includes('employmentTransfer');
        const isCalledToActiveDutyChecked = reasonForTripCancellations.includes('calledToActiveDuty');
        const isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked = reasonForTripCancellations.includes('requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness');
        const isHijackedVictimOfFeloniousAssaultChecked = reasonForTripCancellations.includes('hijackedVictimOfFeloniousAssault');
        const isWeatherOrDisasterChecked = reasonForTripCancellations.includes('weatherOrDisaster');
        const isTrafficAccident = reasonForTripCancellations.includes('trafficAccident');
        const isbankruptcyOfTravelSupplierChecked = reasonForTripCancellations.includes('bankruptcyOfTravelSupplier');
        const isTravelServiceCessationChecked = reasonForTripCancellations.includes('travelServiceCessation');
        const isNaturalDisasterResidenceChecked = reasonForTripCancellations.includes('naturalDisasterResidence');
        const isTerroristIncident = reasonForTripCancellations.includes('terroristIncident');
        const isNoneOfTheAbove = reasonForTripCancellations.includes('None of the Above');
        const isReasonOther = reasonForTripCancellations.includes('reasonOther');
        return (
            <div>
                {tripCancellation === 'true' && (
                    <div className={'ml-3'}>
                        <div className={'col-sm-12 form-group'}>
                            <Validate
                                name="reasonsForTripCancellation"
                                validators={[required]}
                                group={this.props.validatorGroup}
                                addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                                validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                                validationCounter={this.props.validationCounter}
                                validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                                defaultValue={reasonForTripCancellations}
                                fieldName={messages.reasonsForTripCancellation}
                                tooltipContent={messages.reasonsForTripCancellationTooltip.defaultMessage}
                                tooltipDataFor={'reasonsForTripCancellationHint'}
                                tooltipPlace={'bottom'}
                            >
                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isSicknessOrInjuryChecked}
                                        type="checkbox"
                                        name="sicknessOrInjury"
                                        checked={isSicknessOrInjuryChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.sicknessOrInjury} />
                                    </span>
                                </div>

                                <div>
                                    {isSicknessOrInjuryChecked && this.renderSickOrInjured()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isDeathChecked}
                                        type="checkbox"
                                        name="death"
                                        checked={isDeathChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.death} />
                                    </span>
                                </div>
                                <div>
                                    {isDeathChecked && this.renderDeath()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isEmploymentTransferChecked}
                                        type="checkbox"
                                        name="employmentTransfer"
                                        checked={isEmploymentTransferChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.employmentTransfer} />
                                    </span>
                                </div>

                                <div>{isEmploymentTransferChecked && (this.renderEmploymentTransfer())}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isCalledToActiveDutyChecked}
                                        type="checkbox"
                                        name="calledToActiveDuty"
                                        checked={isCalledToActiveDutyChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.calledToActiveDuty} />
                                    </span>
                                </div>
                                <div>{isCalledToActiveDutyChecked && this.renderCalledToActiveDuty()} </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked}
                                        type="checkbox"
                                        name="requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness"
                                        checked={isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.requiredToServeOnAJurySubpoenaedRequireToServeAsAWitness} />
                                    </span>
                                </div>
                                <div>
                                    {isRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitnessChecked && (this.renderRequiredToServeOnAJurySubpoenaedRequireToServeAsAWitness())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isHijackedVictimOfFeloniousAssaultChecked}
                                        type="checkbox"
                                        name="hijackedVictimOfFeloniousAssault"
                                        checked={isHijackedVictimOfFeloniousAssaultChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.hijackedVictimOfFeloniousAssault} />
                                    </span>
                                </div>
                                <div>
                                    {isHijackedVictimOfFeloniousAssaultChecked && (this.renderHijackedVictimOfFeloniousAssault())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isWeatherOrDisasterChecked}
                                        type="checkbox"
                                        name="weatherOrDisaster"
                                        checked={isWeatherOrDisasterChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.weatherOrDisaster} />
                                    </span>
                                </div>
                                <div>
                                    {isWeatherOrDisasterChecked && this.renderWeatherOrDisaster()}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isTrafficAccident}
                                        type="checkbox"
                                        name="trafficAccident"
                                        checked={isTrafficAccident}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.trafficAccident} />
                                    </span>
                                </div>
                                <div>
                                    {isTrafficAccident && (this.renderTrafficAccident())}
                                </div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !isbankruptcyOfTravelSupplierChecked}
                                        type="checkbox"
                                        name="bankruptcyOfTravelSupplier"
                                        checked={isbankruptcyOfTravelSupplierChecked}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.bankruptcyOfTravelSupplier} />
                                    </span>
                                </div>
                                <div>{isbankruptcyOfTravelSupplierChecked && this.renderBankruptcyOfTravelSupplier()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('travelServiceCessation')}
                                        type="checkbox"
                                        name="travelServiceCessation"
                                        checked={reasonForTripCancellations.includes('travelServiceCessation')}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.travelServiceCessation} />
                                    </span>
                                </div>
                                <div>{isTravelServiceCessationChecked && this.renderTravelServiceCessation()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('naturalDisasterResidence')}
                                        type="checkbox"
                                        name="naturalDisasterResidence"
                                        checked={reasonForTripCancellations.includes('naturalDisasterResidence')}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.naturalDisasterResidence} />
                                    </span>
                                </div>
                                <div>{isNaturalDisasterResidenceChecked && this.renderNaturalDisasterResidence()}</div>

                                <div className={'col-sm-12 form-group'}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('terroristIncident')}
                                        type="checkbox"
                                        name="terroristIncident"
                                        checked={reasonForTripCancellations.includes('terroristIncident')}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.terroristIncident} />
                                    </span>
                                </div>
                                <div>{isTerroristIncident && this.renderTerroristIncident()}</div>

                                {/* None of the Above (Cancel For Any Reason) */}
                                <div className={'col-sm-12 form-group'} style={{ display: isRenderTripCancellationForAnyReason ? 'none' : '' }}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('reasonOther')}
                                        type="checkbox"
                                        name="reasonOther"
                                        checked={reasonForTripCancellations.includes('reasonOther')}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span>
                                        <FormattedMessage {...messages.other} />
                                    </span>
                                    {isReasonOther === true &&
                                        <div className={'ml-2 row'}>
                                            <div className={'col-sm-12 form-group'}>
                                                <Validate
                                                    name="other"
                                                    validators={[required]}
                                                    group={this.validatorGroup}
                                                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                                    validationCounter={this.state.validationCounter}
                                                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                                    defaultValue={reasonForTravelCancellation}
                                                    fieldName={messages.reasonForCancellation}
                                                >
                                                    <TextArea
                                                        name="reasonForAirlineReissue"
                                                        type="text"
                                                        onChange={this.handleChange('form.reasonForTravelCancellation')}
                                                        value={reasonForTravelCancellation}
                                                        disabled={isReadOnly}
                                                    />
                                                    <ErrorMessage for="required">
                                                        <FormattedMessage
                                                            {...messages.isRequired}
                                                            values={messages.reasonOther}
                                                        />
                                                    </ErrorMessage>
                                                </Validate>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {/* None of the Above (Cancel For Any Reason) */}
                                <div className={'col-sm-12 form-group'} style={{ display: !isRenderTripCancellationForAnyReason ? 'none' : '' }}>
                                    <input
                                        disabled={(isReadOnly || isOnlyOne) && !reasonForTripCancellations.includes('None of the Above')}
                                        type="checkbox"
                                        name="None of the Above"
                                        checked={reasonForTripCancellations.includes('None of the Above')}
                                        onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                                    />
                                    <span style={{ fontWeight: 'bold' }}>
                                        <FormattedMessage {...messages.noneOfTheAbove} />
                                        <FNOLTooltip place={'top'} dataFor={'noneOfTheAboveHint'} content={messages.noneOfTheAboveTooltip.defaultMessage} />
                                    </span>
                                    {isNoneOfTheAbove === true &&
                                        <div className={'ml-2 row'}>
                                            <div className={'col-sm-12 form-group'}>
                                                <Validate
                                                    name="reasonForCancellation"
                                                    validators={[required]}
                                                    group={this.validatorGroup}
                                                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                                                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                                                    validationCounter={this.state.validationCounter}
                                                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                                                    defaultValue={reasonForTravelCancellation}
                                                    fieldName={messages.reasonForCancellation}
                                                >
                                                    <TextArea
                                                        name="reasonForAirlineReissue"
                                                        type="text"
                                                        onChange={this.handleChange('form.reasonForTravelCancellation')}
                                                        value={reasonForTravelCancellation}
                                                        disabled={isReadOnly}
                                                    />
                                                    <ErrorMessage for="required">
                                                        <FormattedMessage
                                                            {...messages.isRequired}
                                                            values={messages.reasonForCancellation}
                                                        />
                                                    </ErrorMessage>
                                                </Validate>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className={'ml-2 row'}>
                                    <div className={'col-sm-6 form-group'}>
                                        <Validate
                                            name="dateTravelCancellation"
                                            validators={[checkDateOnly, required]}
                                            group={this.props.validatorGroup}
                                            addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                                            validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                                            validationCounter={this.props.validationCounter}
                                            validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                                            defaultValue={dateTravelCancellation}
                                            fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                                        >
                                            <DatePicker
                                                position={'bottom-start'}
                                                disabled={isReadOnly}
                                                name="dateTravelCancellation"
                                                type="text"
                                                onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                                                value={dateTravelCancellation}
                                            />
                                            <ErrorMessage for="required">
                                                <FormattedMessage
                                                    {...messages.isRequired}
                                                    values={messages.dateTripWasCancelledWithTravelSupplier}
                                                />
                                            </ErrorMessage>
                                            <ErrorMessage for="checkDateOnly">
                                                <FormattedMessage
                                                    {...messages.checkEventDate}
                                                    values={messages.dateTripWasCancelledWithTravelSupplier}
                                                />
                                            </ErrorMessage>
                                        </Validate>
                                    </div>
                                    <div className={'col-sm-6 form-group'}>
                                    </div>
                                </div>
                                <div className={'ml-3 mt-3'}>
                                    <PageSectionHeader>
                                        <FormattedMessage
                                            {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
                                        />
                                    </PageSectionHeader>
                                    {this.renderTravelCancellationAdditionalItems()}
                                </div>
                                <ErrorMessage for="required">
                                    <FormattedMessage
                                        {...messages.isRequired}
                                        values={messages.reasonsForTripCancellation}
                                    />
                                </ErrorMessage>
                            </Validate>
                        </div>


                    </div>
                )}
            </div>
        );
    }
}

TripCancellationVersion15AndAbove.propTypes = {
    form: PropTypes.object,
    isSummary: PropTypes.bool,
    submitted: PropTypes.bool,
    isClaimForFieldEnabled: PropTypes.bool,
    isClaimGroupAllowed: PropTypes.bool,
    jsonVersion: PropTypes.number,
    appendIds: PropTypes.func,
    resetFormFields: PropTypes.func,
    onFormDataChange: PropTypes.func,
    onTravelCancellationItemsChange: PropTypes.func,
    onTripInterruptionChange: PropTypes.func,
    insuredsList: PropTypes.array,
    validatorGroup: PropTypes.object,
    validationCounter: PropTypes.number,
    loading: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    getFlightStatus: PropTypes.func,
    stepName: PropTypes.string,
    resetFormFields: PropTypes.func,
    sendPhysicianEmail: PropTypes.func,
};





// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/components/TripCancellationVersion15AndAbove/index.js